import { AlertCircle } from "lucide-react";

interface Props {
  message: string;
}

export function ErrorMessage({ message }: Props) {
  return (
    <p
      role="alert"
      className="callout-danger flex items-start gap-2 px-3.5 py-2.5"
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
